var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5858 11.5858H9.58579V15.1718C9.58574 15.3695 9.52707 15.5628 9.41719 15.7272C9.3073 15.8917 9.15114 16.0198 8.96844 16.0955C8.78574 16.1711 8.58471 16.1909 8.39076 16.1524C8.1968 16.1138 8.01864 16.0186 7.87879 15.8788L1.29279 9.29279C1.10532 9.10526 1 8.85095 1 8.58579C1 8.32062 1.10532 8.06631 1.29279 7.87879L7.87879 1.29279C8.01864 1.15298 8.1968 1.05777 8.39076 1.0192C8.58471 0.980636 8.78574 1.00044 8.96844 1.07611C9.15114 1.15178 9.3073 1.27992 9.41719 1.44433C9.52707 1.60874 9.58574 1.80204 9.58579 1.99979V5.58579H17.5858C17.851 5.58579 18.1054 5.69114 18.2929 5.87868C18.4804 6.06622 18.5858 6.32057 18.5858 6.58579V10.5858C18.5858 10.851 18.4804 11.1054 18.2929 11.2929C18.1054 11.4804 17.851 11.5858 17.5858 11.5858Z",
    stroke: "#2AA7E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrow);
export default __webpack_public_path__ + "static/media/back arrow.186617f13a84f3a60b9648edb128b778.svg";
export { ForwardRef as ReactComponent };